'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
var _excluded = ["className"],
  _excluded2 = ["className", "children"];
var _FilterTabs, _FilterFooter;
import * as React from 'react';
import { Popper, PopperContent } from "../Popper";
import { FilterFooter, FilterHeader, FilterTabs } from "./components";
import { SelectorGenerator } from "./selector-generator";
import { jsx as _jsx } from "react/jsx-runtime";
var FiltersDropdown = /*#__PURE__*/React.forwardRef(function (_ref2, _ref) {
  var _ref2$optionsSelector = _ref2.optionsSelector,
    optionsSelector = _ref2$optionsSelector === void 0 ? [] : _ref2$optionsSelector;
  return /*#__PURE__*/_jsx(SelectorGenerator, {
    optionsSelector: optionsSelector
  });
});
FiltersDropdown.displayName = 'FiltersDropdown';
var FiltersWrapper = /*#__PURE__*/React.forwardRef(function (_ref3, _ref) {
  var children = _ref3.children;
  return /*#__PURE__*/_jsx(PopperContent, {
    removePadding: true,
    align: "end",
    side: "bottom",
    removePortal: true,
    children: children
  });
});
FiltersWrapper.displayName = 'FiltersWrapper';
var FiltersTabs = /*#__PURE__*/React.forwardRef(function (_ref4, _ref) {
  _objectDestructuringEmpty(_ref4);
  return _FilterTabs || (_FilterTabs = /*#__PURE__*/_jsx(FilterTabs, {}));
});
FiltersTabs.displayName = 'FiltersTabs';
var FiltersHeader = /*#__PURE__*/React.forwardRef(function (_ref5, _ref) {
  var onSearch = _ref5.onSearch,
    setFocusEvent = _ref5.setFocusEvent,
    sortItems = _ref5.sortItems;
  return /*#__PURE__*/_jsx(FilterHeader, {
    onSearch: onSearch,
    setFocusEvent: setFocusEvent,
    sortItems: sortItems
  });
});
FiltersHeader.displayName = 'FiltersHeader';
var FiltersContent = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, props), {}, {
    children: props.children
  }));
});
FiltersContent.displayName = 'FiltersContent';
var FiltersFooter = /*#__PURE__*/React.forwardRef(function (_ref7, _ref) {
  _objectDestructuringEmpty(_ref7);
  return _FilterFooter || (_FilterFooter = /*#__PURE__*/_jsx(FilterFooter, {}));
});
FiltersFooter.displayName = 'FiltersFooter';
var Filters = /*#__PURE__*/React.forwardRef(function (_ref8, ref) {
  var className = _ref8.className,
    children = _ref8.children,
    props = _objectWithoutProperties(_ref8, _excluded2);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, props), {}, {
    children: /*#__PURE__*/_jsx(Popper, {
      open: true,
      children: children
    })
  }));
});
Filters.displayName = 'Filters';
export { Filters, FiltersDropdown, FiltersTabs, FiltersWrapper, FiltersHeader, FiltersContent, FiltersFooter };